import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatProgressBar} from '@angular/material/progress-bar';
import {UserService} from '../../../shared/services/user.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {StorageService} from '../../../shared/services/storage.service';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {CurrentUser} from '../../../shared/models/current-user.model';
import {PopupWindowsService} from '../../../shared/services/popup-windows.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
    forgotPasswordForm: FormGroup = new FormGroup({
        userEmail: new FormControl('', Validators.required)
    });
    userEmail: FormControl;
    @ViewChild(MatProgressBar) progressBar: MatProgressBar;
    @ViewChild(MatButton) submitButton: MatButton;
    sent: boolean;
    notExists: boolean;
    currentUser$: Observable<CurrentUser>;

    constructor(
        private userService: UserService,
        private store: Store,
        private storageService: StorageService,
        private popupWindowsService: PopupWindowsService
    ) {
        this.currentUser$ = this.store.select(state => state.currentUser.currentUser);
    }

    ngOnInit() {
    }

    submitEmail() {
        this.submitButton.disabled = true;
        this.progressBar.mode = 'indeterminate';
        this.userService.restorePassword(this.forgotPasswordForm.value.userEmail).subscribe(
            data => {
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';
                this.sent = true;
                this.notExists = false;
                this.forgotPasswordForm.markAsPristine();
            },
            err => {
                this.sent = false;
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';
                if (err.status === 404) {
                    this.notExists = true;
                    this.forgotPasswordForm.markAsPristine();
                } else {
                  this.popupWindowsService.openErrorDialogWindow({message: err.error.detail});
                }
            }
        );
    }

}
